import * as React from 'react';
import { useState, useEffect } from 'react';
import storefrontService from '../services/Storefront';
import { useStorefrontSettings } from './StorefrontSettingsContext';
import Localization from '../services/Localization';
import * as Components from '../resources/Components';

const DashboardConfigContext = React.createContext();

function DashboardConfigProvider({ children, ...props }) {

    // have all the config settings here.
    const [DashboardConfigLoaded, setDashboardConfigLoaded] = useState(false);
    const [settings, setSettings] = useState(props.settings || []);
    const [childComponents, setChildComponents] = useState(props.childComponents || {});
    const [labels, setLabels] = React.useState({});
    const [labelsLoaded, setLabelsLoaded] = React.useState(false);
    const { locale } = useStorefrontSettings();

    // might have to just make this a parameter that gets passed in
    const storefrontNumber = ('00000' + props.storefrontNumber).slice(-5);

    // useEffect?
    useEffect(() => {
        getDashboardSettings();
    }, []);

    useEffect(() => {
        Localization.getComponentLabels(Components.DASHBOARD, locale, storefrontNumber)
            .then(res => {
                setLabels(res);
            })
    }, [locale]);

    // fetchSettings
    const getDashboardSettings = () => {
        storefrontService.getDashboardSettings(storefrontNumber).then((res) => {
            setSettings(res.settings || []);
            setChildComponents(res.childComponents || []);
            setDashboardConfigLoaded(true);
        });
    }

    return (
        <DashboardConfigContext.Provider
            value={{
                settings,
                childComponents,
                DashboardConfigLoaded,
                labels
            }}
        >
            {children}
        </DashboardConfigContext.Provider >
    );
}

function useDashboardConfig() {
    const context = React.useContext(DashboardConfigContext);
    if (context === undefined) {
        throw new Error('DashboardConfigContext must be used within a DashboardConfigContext');
    }

    return context;
}

function withDashboardConfig(Component) {
    return function WrappedComponent(props) {
        const DashboardConfig = useDashboardConfig();
        return <Component {...props}
            DashboardConfig={DashboardConfig}
        />;
    }
}

export { DashboardConfigProvider, useDashboardConfig, withDashboardConfig }